import { reportIdNotRemoteLogoutSkipped } from "@Front/Api/Auth/IdNot/helpers/idNotRemoteLogoutSkipped";

/**
 * Previously loaded IdNot logout in a hidden iframe; IdNot CSP (frame-ancestors) blocks that.
 * Session cleanup is handled by callers; IdNot authorize uses prompt=login.
 */
export async function revokeIdNotCookiesViaIframe(): Promise<void> {
	await reportIdNotRemoteLogoutSkipped("SessionRefresh");
}
